import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import { useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { inquirySubmit } from "../../redux/features/inquiry/inquiryService";
import { BeatLoader } from "react-spinners";
import { getCountry } from "../../redux/features/country/countryService";
import { countries } from 'countries-list';
import { ToastContainer } from "react-toastify";
import { showToast } from "../ToastMsg";
import Dropdown from "../Dropdown/Dropdown";

const countryList = Object.entries(countries).map(([code, info]) => ({
  code,
  name: info.name,
}));

const countryOptions = countryList.map((country) => ({
  id: country.code,
  name: country.name,
}));

const QuotaCard = ({ id }) => {
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);

  const [disabledBtn, setDisabledBtn] = useState(false);

  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [error, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    dispatch(getCountry({ status: true }));
  }, [dispatch]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setErrors({ ...error, [e.target.name]: "" });
  };

  const handleSelect = (country) => {
    setSelectedCountry(country);
  };

  const validatePayment = () => {
    const errors = {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      message: "",
    };

    if (!data.firstName) errors.firstName = "First Name is required!";
    if (!data.email) errors.email = "Email is required!";
    else if (!/\S+@\S+\.\S+/.test(data.email))
      errors.email = "Invalid email format!";
    if (!data.phoneNumber) errors.phoneNumber = "Phone Number is required!";
    if (!data.message) errors.message = "Message is required!";

    setErrors(errors);
    return !Object.values(errors).some((err) => err);
  };

  const handleSubmit = async () => {
    if (validatePayment()) {
      setDisabledBtn(true);
      try {
        const response = await dispatch(
          inquirySubmit({
            id: id,
            first_name: data.firstName,
            last_name: data.lastName,
            email: data.email,
            phone_number: data.phoneNumber,
            message: data.message,
            country: selectedCountry?.name,
          })
        ).unwrap();

        if (response.success) {
          showToast('success', response.message);
          if (dropdownRef.current?.clearSelection) {
            dropdownRef.current.clearSelection();
          }
          setSelectedCountry(null);
          setData({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: "",
            message: "",
          });
        } else {
          showToast('error', response.message);
        }
      } catch (error) {
        showToast('error', error.message);
      } finally {
        setDisabledBtn(false);
      }
    }
  };

  return (
    <>
      <div className={styles.mainDiv}>
        <ToastContainer />
        <h1>Get Free Quote</h1>

        <form className={styles.quotaForm}>
          <input
            type="text"
            name="firstName"
            value={data.firstName}
            onChange={handleChange}
            className={error.firstName ? styles.inputError : ""}
            placeholder="First Name"
          />
          {error.firstName && (
            <span className={styles.errorMsg}>{error.firstName}</span>
          )}

          <input
            type="text"
            name="lastName"
            value={data.lastName}
            onChange={handleChange}
            className={error.lastName ? styles.inputError : ""}
            placeholder="Last Name"
          />
          {error.lastName && (
            <span className={styles.errorMsg}>{error.lastName}</span>
          )}

          <input
            type="email"
            name="email"
            value={data.email}
            onChange={handleChange}
            className={error.email ? styles.inputError : ""}
            placeholder="Email"
          />
          {error.email && (
            <span className={styles.errorMsg}>{error.email}</span>
          )}

          <input
            type="text"
            name="phoneNumber"
            value={data.phoneNumber}
            onChange={handleChange}
            className={error.phoneNumber ? styles.inputError : ""}
            placeholder="Phone Number"
          />
          {error.phoneNumber && (
            <span className={styles.errorMsg}>{error.phoneNumber}</span>
          )}
          <Dropdown
            ref={dropdownRef}
            options={countryOptions}
            onSelect={handleSelect}
            placeholder="Select a Country"
            value={selectedCountry?.name}
          />
          <textarea
            name="message"
            rows={5}
            value={data.message}
            onChange={handleChange}
            className={error.message ? styles.inputError : ""}
            placeholder="Enter your message"
          />
          {error.message && (
            <span className={styles.errorMsg}>{error.message}</span>
          )}

          <button className={styles.quoteLink} disabled={disabledBtn} onClick={handleSubmit} type="button">
            {disabledBtn? <BeatLoader/> : `Get Free Quote`}
          </button>

          <button className={styles.whatsappLink} type="button">
            Whatsapp
          </button>
        </form>
      </div>
    </>
  );
};

export default QuotaCard;